module.exports = __webpack_public_path__ + "img/FRONT_LOADER.44f67256.svg";